import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../client";
import type { UserMarketsUserMarketsIO } from "../../generated/fresh-guard-api";
import { queryKeys } from "../query-keys";

export function useUserMarketsUpdate() {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: async (input: {
      userMarketsUserMarketsIO: UserMarketsUserMarketsIO;
    }) => {
      const res = await api.userMarketsApi.apiUserMarketsPost(
        input.userMarketsUserMarketsIO,
      );
      return res.data;
    },
    onSettled: (_data, _err, variables) => {
      const username = variables.userMarketsUserMarketsIO.username;

      if (username) {
        void qc.invalidateQueries({
          queryKey: queryKeys.userMarkets.byUsername(username),
        });
      }
    },
    meta: {
      skipGlobalError: false,
    },
  });
}
